import { useNavigate } from "react-router-dom";

export default function PlayerCard({ p, i, proj, lvl, leagueId }) {
  const level = lvl?.training_level ?? 0;
  const equippedSkin = p.equipped_skin;
  const navigate = useNavigate();
  const playerImage = equippedSkin?.full_preview || p.players.player_image;

  return (
    <div className={`player-card card-${i}`}>
      {proj !== undefined && proj !== null ? (
        <div className="projected-points">
          <p style={{ opacity: "0.6" }}>VS</p>
          <img src={`/teams/${proj.opponent_logo}`} alt={proj.opponent_name} />
        </div>
      ) : (
        <div className="projected-points">
          <p style={{ opacity: "0.4", fontSize: "9px", textAlign: "center", lineHeight: "1.2" }}>
            NO MATCH
            <br />
            THIS WEEK
          </p>
        </div>
      )}
      {/* <div className="level-hexagon">
        <p>{level}</p>
      </div>
      <div className="level-hexagon-border"></div> */}
      <div
        className="shimmer-wrapper"
        style={{ borderRadius: "4px", cursor: "pointer" }}
        onClick={() => navigate(`/dashboard/league/${leagueId}/player/${p.player_id}`)}>
        <img src={`/players/${playerImage}`} alt={p.players.name} />
      </div>

      <div className="boost-info">
        {p.boosts && p.boosts.id !== "no_boost" ? (
          <>
            <div className="boost-glare"></div>
            <img src={`/boosts/${p.boosts.item_image}`} alt={p.boosts.name} />
          </>
        ) : (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px dashed rgba(255, 100, 100, 0.5)",
              borderRadius: "6px",
              background: "rgba(255, 60, 60, 0.26)",
              fontSize: "14px",
            }}
            title={`${p.players.name} has no item equipped`}>
            ⚠️
          </div>
        )}
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        {proj !== undefined && proj !== null ? (
          (() => {
            const pg = proj.projected_points_per_game ?? 0;
            const background =
              pg >= 32
                ? "linear-gradient(53.32deg, #eae3da 25.96%, #bfe6ef 41.34%, #e1e3f5 59.82%, #e6badd 70.04%, #e8f6ef 80.25%)"
                : pg >= 28
                  ? "linear-gradient(135deg, #00f3eb, #00f3eb)"
                  : pg >= 22
                    ? "linear-gradient(135deg, #25ed36, #25ed36)"
                    : pg >= 20
                      ? "linear-gradient(135deg, #ff7e34, #ff7e34)"
                      : "linear-gradient(135deg, #ef4444, #fca5a5)";

            const textShadow =
              pg >= 34
                ? `0 0 6px #bfe6ef, 0 0 12px #bfe6ef, 0 0 24px #bfe6ef,
           0 0 36px #bfe6ef, 0 0 52px #bfe6ef, 0 0 64px #bfe6ef`
                : "";

            return (
              <h3 className="average-performance-bubble" style={{ background, textShadow, border: "1px solid #ffffff00" }}>
                {pg?.toFixed(0) ?? "0"}
              </h3>
            );
          })()
        ) : (
          <h3
            className="average-performance-bubble"
            style={{ background: "linear-gradient(135deg, #2a2a2a, #1a1a1a)", border: "1px solid #ffffff15", opacity: 0.5 }}>
            —
          </h3>
        )}
        {level > 0 && (
          <div
            className="average-performance-bubble"
            style={{
              background:
                "conic-gradient(from 0deg, #ffe3c4 6%, #ffb45c 18%, #ff912f 32%, #ffca00 46%, #ffd100 58%, #ffd9b2 72%, #ff8a18 84%, #ff7f1f 92%)",
              border: "1px solid #ffffff38",
            }}>
            <p style={{ color: "white", margin: "0", textShadow: "0px 0px 4px rgba(0, 0, 0, 0.6)", fontWeight: "700" }}>+{level * 2}%</p>
          </div>
        )}
      </div>
    </div>
  );
}
